/* eslint-disable @typescript-eslint/no-empty-interface */
import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {DiscountTimeEnum, rewardTypeEnum} from './constant'

// [活动状态] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134972715
export const open_discount_time = createAsyncThunk(
  '/live/facetime/open_discount_time',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<DiscountTime>>(
      '/live/facetime/open_discount_time',
      {
        ...store.getState().env.deviceinfo,
        // ...arg,
        from_h5: true,
      }
    )
    return resp.data.data
  }
)

interface DiscountTime {
  err_msg: string // 错误信息
  status: DiscountTimeEnum // 状态码
  time_stamp: number // 活动倒计时
  is_white: boolean // 是否是三方白名单用户
  is_open_rank: boolean // 是否开启榜单
  time_str: string // 活动时间字符串
}

// // [获取官方商品列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134973010
// export const get_official_products_list = createAsyncThunk(
//   '/live/pay/get_official_products_list',
//   async (arg, store: any) => {
//     const resp = await http.post<HiyaRes<any>>(
//       '/live/pay/get_official_products_list',
//       {
//         ...store.getState().env.deviceinfo,
//       }
//     )
//     return resp.data.data
//   }
// )
// [获取官方商品列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134973010
export const get_official_products_list = createAsyncThunk(
  '/live/pay/get_open_discount_products_list',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/pay/get_open_discount_products_list',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// [用户榜单-榜单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134975204
export const open_discount_rank = createAsyncThunk(
  '/live/facetime/open_discount_rank',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/open_discount_rank',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
// [用户榜单-我的] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134972729
export const open_discount_user_info = createAsyncThunk(
  '/live/facetime/open_discount_user_info',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/open_discount_user_info',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// [首页用户任务] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134973910
export const user_click_show_big_bang_task = createAsyncThunk(
  '/live/facetime/user_click_show_big_bang_task',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/user_click_show_big_bang_task',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)
export interface RewardCfg {
  reward_name: string // 任务奖励名称
  reward_num: number // 任务奖励数量
  reward_icon: string // 奖励的图标链接
  reward_type_id: number // 奖励的类型
}
export interface RewardWindowInfo {
  title: string
  reward: RewardCfg[] // 奖励信息
  go_chat_link: string // 去聊天按钮的跳转链接
  more_rewards_link: string // 查看更多奖励按钮的链接
}
export interface ClaimRes {
  err_msg?: string
  data?: RewardWindowInfo // 领取弹窗中的信息
}
// [点击“领取”奖励的接口] http://wiki.xunlei.cn/pages/viewpage.action?pageId=127575347
export const user_click_claim_task = createAsyncThunk(
  '/live/facetime/user_click_claim_task_big_bang',
  async (
    arg: Pick<TaskItem, 'task_id' | 'task_sub_type' | 'task_type'>,
    store: any
  ) => {
    const resp = await http.post<HiyaRes<ClaimRes>>(
      '/live/facetime/user_click_claim_task',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      },
      {xcErrorToast: true}
    )
    return resp.data.data
  }
)

// [历史用户榜单] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134972722
export const open_discount_history_rank = createAsyncThunk(
  '/live/facetime/open_discount_history_rank',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/open_discount_history_rank',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// [活动奖励] http://wiki.xunlei.cn/pages/viewpage.action?pageId=134974237
export const open_discount_reward_list = createAsyncThunk(
  '/live/facetime/open_discount_reward_list',
  async (arg, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/open_discount_reward_list',
      {
        ...store.getState().env.deviceinfo,
      }
    )
    return resp.data.data
  }
)

// [h5全局任务完成弹窗需要的信息] http://wiki.xunlei.cn/display/zdxm/user_task_complete_get_window
export const user_task_complete_get_window = createAsyncThunk(
  '/live/facetime/user_task_complete_get_window',
  async (arg: any, store: any) => {
    const resp = await http.post<HiyaRes<any>>(
      '/live/facetime/user_task_complete_get_window',
      {
        ...store.getState().env.deviceinfo,
        ...arg,
      }
    )
    return resp.data.data
  }
)

export interface RankItem {
  rank: number
  score: number
  user_info: {
    mid: number
    name: string
    avatar: string
  }
}
export interface RewardItem {
  id: number
  reward_type: number
  num: string
  days: number
  url: string
  price: number
  name: string
}
export interface TaskItem {
  // 回传
  task_id: number
  task_type: string
  task_sub_type: string
  // 展示
  task_icon: string
  task_title: string
  task_describe: string
  // 按钮
  button_str: string
  // 按钮/任务的状态
  // 0：待完成/去完成
  // 1：待领取
  // 2：已完成
  button_status: 0 | 1 | 2
  link: string
  reward: RewardCfg[]
  sub_task_process: number // 任务进度
  sub_task_target_process: number // 任务目标进度
}

export interface IProductsListItem {
  id: string
  currency: string
  price: number
  coins: number
  activity_bonus: {
    tag: string // 赠送比例标签
    total_coin: number // 总金币
    limit: number // 最多享受优惠几次
    num: number // 当前享受优惠了几次
    weight: number // 权重,活动页用来排序
    desc: string // 多多少金币
  }
}

export interface InitialStateType {
  History?: Array<{
    date: string
    history_list: Array<RankItem>
  }>
  Home?: {
    list: Array<RankItem>
    my: RankItem
    taskList: Array<TaskItem>
  }
  discountTime?: Partial<DiscountTime>
  productsList?: Array<IProductsListItem>
  rewardRankList?: Array<{
    rank: string
    reward_list: Array<RewardItem>
  }>
  rewardRuleNum?: number
}
const initialState: InitialStateType = {
  productsList: [],
}

export const OpeningCeremonySlice = createSlice({
  name: 'OpeningCeremony',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(open_discount_history_rank.fulfilled, (state, action) => {
      Object.assign(state, {
        ...state,
        History: action.payload.list || [],
      })
    })
    builder.addCase(open_discount_user_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...state,
        Home: {
          ...state.Home,
          my: action.payload.rank_info,
        },
      })
    })
    builder.addCase(open_discount_rank.fulfilled, (state, action) => {
      Object.assign(state, {
        ...state,
        Home: {
          ...state.Home,
          list: action.payload.list,
        },
      })
    })
    builder.addCase(open_discount_time.fulfilled, (state, action) => {
      Object.assign(state, {
        ...state,
        discountTime: action.payload || {},
      })
    })
    builder.addCase(get_official_products_list.fulfilled, (state, action) => {
      Object.assign(state, {
        ...state,
        productsList: action.payload.list || [],
      })
    })
    builder.addCase(open_discount_reward_list.fulfilled, (state, action) => {
      Object.assign(state, {
        ...state,
        rewardRankList: action.payload.list || [],
        rewardRuleNum: action.payload.rule_num,
      })
    })
    builder.addCase(
      user_click_show_big_bang_task.fulfilled,
      (state, action) => {
        Object.assign(state, {
          ...state,
          Home: {
            ...state.Home,
            taskList: action.payload.big_bang_task_lst_info.big_bang_task_lst,
          },
        })
      }
    )
  },
})
export default OpeningCeremonySlice.reducer
export const OpeningCeremonyActions = OpeningCeremonySlice.actions

export const useOpeningCeremonyState = () => {
  const data = useSelector((state) => {
    return state.OpeningCeremony
  })
  return data
}
